import React, { useState } from 'react';
import Select from 'components/shared/select';
import { Button } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const REASON_TYPES = [
  {
    name: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.webcam_microphone',
    ),
    id: 0,
  },
  {
    name: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.unable_to_record',
    ),
    id: 1,
  },
  {
    name: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.recorded_too_long_to_process',
    ),
    id: 2,
  },
  {
    name: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.uploaded_too_long_to_process',
    ),
    id: 3,
  },
  {
    name: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.unable_to_process',
    ),
    id: 4,
  },
  {
    name: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.other',
    ),
    id: 5,
  },
];

const ReportTechnicalDifficultiesForm = ({
  handleShowReportTechnicalDifficulties,
  handleShowSkippedSuccess,
  disabled,
}) => {
  const [selectedReasonType, setSelectedReasonType] = useState('');
  const [reasonInput, setReasonInput] = useState();

  const handleReasonTypeChange = e => {
    setSelectedReasonType(e.target.value);
  };

  const handleReasonInputChange = e => {
    setReasonInput(e.target.value);
  };

  return (
    <div className="ReportTechnicalDifficultiesContainer bg-gray-lightest pos-r mt-8">
      <div className="NewPopover-arrow" />
      <div className="ReportTechnicalDifficultiesContainer-header d-f fd-r jc-sb ai-c c-brand-gray-darkest bg-white py-8 px-16">
        <Text className="mr-4" variant={TEXT_VARIANTS.BODY_BOLD}>
          {t(
            'practice.on_demand_practice.audio_recording.skip_recording.report_technical_difficulties_title',
          )}
        </Text>
      </div>
      <div>
        <div className="bg-gray-lightest px-16 d-f fd-c ff-ss">
          <div className="Select py-16">
            <Select
              name="reason"
              id="reason"
              value={selectedReasonType}
              onChange={handleReasonTypeChange}
              ariaLabel={t(
                'practice.on_demand_practice.audio_recording.skip_recording.reason_types.select_issue',
              )}
            >
              <option value="">
                {t(
                  'practice.on_demand_practice.audio_recording.skip_recording.reason_types.select_issue',
                )}
              </option>
              {REASON_TYPES.map(reason => (
                <option key={reason.id} value={reason.id}>
                  {reason.name}
                </option>
              ))}
              {/* The <optgroup> below was only added because of how it positively
              impacts  select element styling on some mobile browsers and does
              not serve any functional purpose. */}
              <optgroup style={{ display: 'none' }} label="" />
            </Select>
          </div>
          <Text
            variant={TEXT_VARIANTS.BODY}
            component="textarea"
            id="AssignModal-messageInput"
            className="ReportTechnicalDifficultiesContainer-input w-fill p-10 mb-16"
            value={reasonInput}
            onChange={handleReasonInputChange}
            placeholder={t(
              'practice.on_demand_practice.audio_recording.skip_recording.details_placeholder_text',
            )}
          />
        </div>
      </div>
      <div className="d-f fd-r jc-e pr-16 pb-16">
        <button
          type="button"
          className="u-linkBtn"
          onClick={handleShowReportTechnicalDifficulties}
        >
          {t('common.cancel')}
        </button>
        <Button
          disabled={
            selectedReasonType === '' ||
            !reasonInput ||
            reasonInput.trim().length < 1 ||
            disabled
          }
          customColor
          className="ReportTechnicalDifficultiesSubmit px-14 ta-c"
          onClick={() =>
            handleShowSkippedSuccess(reasonInput, selectedReasonType)
          }
        >
          {t(
            'practice.on_demand_practice.audio_recording.skip_recording.button_submit_feedback',
          )}
        </Button>
      </div>
    </div>
  );
};

export default ReportTechnicalDifficultiesForm;
